import { create } from 'zustand';

const ACTIVE_COMPANY_STORAGE_KEY = '#organization#active-company';

interface State {
  activeCompanyId?: string;
  setActiveCompanyId: (id: string) => void;
  unsetActiveCompany: () => void;
}

export const organizationStore = create<State>((set) => ({
  activeCompanyId:
    localStorage.getItem(ACTIVE_COMPANY_STORAGE_KEY) ?? undefined,
  setActiveCompanyId: (id) => {
    localStorage.setItem(ACTIVE_COMPANY_STORAGE_KEY, id);
    return set({ activeCompanyId: id });
  },
  unsetActiveCompany: () => {
    localStorage.removeItem(ACTIVE_COMPANY_STORAGE_KEY);
    return set({ activeCompanyId: undefined });
  },
}));
